import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import * as PaidTicketUseAPI from "@/api/analysis/paid-ticket-use";
import { isSuccess } from "@/api/response";
import { PaidTicketUseGetRequest } from "@/api/analysis/paid-ticket-use/request";
import { PaidTicketUseGetResponse } from "@/api/analysis/paid-ticket-use/response";
import { AnalysisGraphData } from "@/api/analysis/common/response";

const MODULE_NAME = "analysis/paid-ticket-use/get";

/**
 *  デジタルチケット利用数取得API（/analysis-paid-ticket-use）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Get extends VuexModule {
  // state
  getRequest: PaidTicketUseGetRequest = {} as PaidTicketUseGetRequest;
  getResponse: PaidTicketUseGetResponse = {} as PaidTicketUseGetResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.getResponse);
  }

  get getMessage() {
    return this.getResponse.message;
  }

  get getData() {
    if (this.getResponse.results) {
      return this.getResponse.results.data;
    } else {
      return {} as AnalysisGraphData;
    }
  }

  get getTotalCount() {
    if (this.getResponse.results) {
      return this.getResponse.results.totalCount || 0;
    } else {
      return 0;
    }
  }

  get getGetRequest() {
    return this.getRequest;
  }
  // MutationActions
  @MutationAction
  async get(getRequest: PaidTicketUseGetRequest) {
    const getResponse = await PaidTicketUseAPI.get(getRequest);
    return {
      getResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      getResponse: {} as PaidTicketUseGetResponse
    };
  }
}

export default getModule(Get);
